export async function fetchJson(url) {
    return fetch(url)
        .then((response) => {
        if (response.ok) {
            return response.json();
        }
        return Promise.reject('Could not fetch');
    })
        .catch((e) => {
        console.log(e);
    });
}
//# sourceMappingURL=JSONController.js.map